import {GenericModal} from "~/components/genericModal";
import {AnankeButton} from "@vesta/ananke/components/anankeButton";
import {AnankeText} from "@vesta/ananke/components/anankeText";
import {VerticalSpacer} from "@vesta/global-common-typescript/components/verticalSpacer";

export function NoteDeleteConfirmationModal({
    opened,
    onClose,
    onConfirm,
    isDeleting = false,
}: {
    opened: boolean;
    onClose: () => void;
    onConfirm: () => void;
    isDeleting?: boolean;
}) {
    return (
        <GenericModal
            opened={opened}
            onClose={onClose}
            withCloseButton={false}
            title="Are you sure you want to delete ?"
            size="sm"
            zIndex={220}
        >
            <AnankeText
                size="medium"
                color="color.text"
            >
                Are you sure you want to delete this Note, this cannot be undone
            </AnankeText>

            <VerticalSpacer className="h-4" />

            <div className="w-full grid grid-flow-col justify-end gap-2">
                <AnankeButton
                    type="button"
                    appearance="default"
                    onClick={onClose}
                    isDisabled={isDeleting === true}
                >
                    Cancel
                </AnankeButton>
                <AnankeButton
                    type="button"
                    appearance="danger"
                    onClick={onConfirm}
                    isLoading={isDeleting === true}
                    isDisabled={isDeleting === true}
                >
                    Delete
                </AnankeButton>
            </div>
        </GenericModal>
    );
}
